import { useMemo } from 'react';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import Image from '../atoms/Image';
import { getAspectTranslationKey } from '../../data/Score';
import type { Aspect } from '../../data/Score';
import { getAspectImage } from '../../assets/Assets';

const Container = styled.div`
	align-items: stretch;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	font: ${(props) => props.theme.font.default};
	font-weight: bold;
	min-width: 18vmin;
`;

const IconAndPoints = styled.div`
	align-items: flex-end;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
`;

const Value = styled.span`
	margin-left: 0.4rem;
	font-size: 5.2vmin;
	line-height: 4.4vmin;
	vertical-align: bottom;
`;

const Name = styled.span`
	margin-top: 0.4rem;
	font-size: 3vmin;
	text-align: right;
`;

export interface Props {
	aspect: Aspect;
}

const AspectPoints: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { aspect, children } = props;
	const aspectImage = useMemo(() => getAspectImage(aspect), [aspect]);
	const aspectTranslationKey = useMemo(
		() => getAspectTranslationKey(aspect),
		[aspect]
	);

	return (
		<Container>
			<IconAndPoints>
				<Image src={aspectImage} width="8vmin" height="8vmin" />
				<Value>{children}</Value>
			</IconAndPoints>
			<Name>
				<Trans>{aspectTranslationKey}</Trans>
			</Name>
		</Container>
	);
};

export default AspectPoints;
